import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import TableCompo from "../Table/TableCompo";
import {
  assignCountriesRequest,
  fetchCountryRequest,
  removeCountryRequest,
  updateCountryRequest,
} from "../../../redux/CountryList/CountrySlice";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const CountryTableList = ({ onEdit }) => {
  const dispatch = useDispatch();
  const {
    countries = [],
    loading,
    error,
    total,
    page: currentPage = 0,
    limit,
  } = useSelector((state) => state.country || {});

  const [pagination, setPagination] = useState({
    page: currentPage,
    limit: limit || 5,
  });
  const [searchText, setSearchText] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(
      fetchCountryRequest({
        page: pagination.page,
        limit: pagination.limit,
        search: searchText,
      })
    );
  }, [dispatch, pagination, searchText]);

  const handleTableChange = (action, tableState) => {
    if (action === "changePage")
      setPagination((prev) => ({ ...prev, page: tableState.page }));
    else if (action === "changeRowsPerPage")
      setPagination({ page: 0, limit: tableState.rowsPerPage });
    else if (action === "search") {
      setSearchText(tableState.searchText || "");
      setPagination((prev) => ({ ...prev, page: 0 }));
    }
  };

  const handleEnableDisableClick = (row) => {
    setSelectedRow(row);
    setOpenConfirm(true);
  };

const handleConfirm = () => {
  if (selectedRow) {
    const payload = { id: selectedRow._id };

    if (selectedRow.isenabled) {
      dispatch(removeCountryRequest(payload));
    } else {
      dispatch(assignCountriesRequest(payload));
    }
  }
  setOpenConfirm(false);
};

  const handleCancel = () => {
    setOpenConfirm(false);
    setSelectedRow(null);
  };

  const columns = [
    { field: "countryName", headerName: "Country Name" },
    { field: "countryCode", headerName: "Country Code" },
    { field: "dialCode", headerName: "Dial Code" },
    { field: "currency", headerName: "Currency" },
    { field: "currencySymbol", headerName: "Currency Symbol" },
    { field: "phoneLength", headerName: "Phone Length" },
    {
      field: "edit",
      headerName: "Edit",
      render: (_, row) => (
        <CiEdit
          style={{ cursor: "pointer" }}
          onClick={() => onEdit(countries.find((c) => c._id === row._id))}
        />
      ),
      hideInExcel: true,
    },
    {
      field: "status",
      headerName: "Status",
      render: (_, row) => (
        <Button
          variant="contained"
          style={{
            backgroundColor: row.isenabled ? "green" : "#d32f2f",
            color: "white",
            textTransform: "none",
          }}
          onClick={() => handleEnableDisableClick(row)}
        >
          {row.isenabled ? "Enabled" : "Disabled"}
        </Button>
      ),
      hideInExcel: true,
    },
  ];

  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <TableCompo
          columns={columns}
          data={Array.isArray(countries) ? [...countries].reverse() : []}
          loading={loading}
          totalCount={total}
          page={pagination.page}
          limit={pagination.limit}
          onTableChange={handleTableChange}
        />
      )}

      <Dialog open={openConfirm} onClose={handleCancel}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to{" "}
            <b>
              {selectedRow?.isenabled ? "disable" : "enable"}{" "}
              {selectedRow?.countryName}
            </b>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancel}
            variant="contained"
            sx={{ backgroundColor: "#d32f2f", color: "white" }}
          >
            No
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{ backgroundColor: "green", color: "white" }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CountryTableList;
